import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import AuthService from "services/API/Auth/AuthService";
import EPService from 'services/API/expo_partecipazioni/ExpoPartecipazioniService';

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import DashboardLayout from "layouts/DashboardLayout";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
// @mui material components
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import ExpoRichiesteVis from "pages/riservata/expo_richieste/ExpoRichiesteVis";

//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

//script
import MDInput from "common/components/MD/MDInput";
import { Icon, MenuItem } from "@mui/material";
import UtilityService from "services/API/utility/UtilityService";
import ReactHookFormCheckBox from "common/components/mycomponents/ReactHookFormCheckBox";
import MDTypography from "common/components/MD/MDTypography";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import DriveEtaRoundedIcon from '@mui/icons-material/DriveEtaRounded';
import LocalAtmRoundedIcon from '@mui/icons-material/LocalAtmRounded';
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';

const ExpoDotazioniEdit = () => {

    const location = useLocation();
    const navigate = useNavigate();


    const [ffcontroller] = useFarFieraUIController();
    const { manifestazione } = ffcontroller;


    const { modo, id_soggetto, chiamante } = location.state;
    // user state for form
    // user state for form
    const [richiesta, setRichiesta] = useState({
        idRichiesta: 0,
        ragione_sociale: '',
        dotazioni: [{
            id_dotazione: 0,

        }]
    });


    const [lista_dotazioni, setLista_dotazioni] = useState([{ id_dotazione: 0, tipo_dotazione: 'PE' }]);


    /*---------------------------------------CARICAMENTO DELLE COSE CHE SERVONO-------------------------------------*/



    /* ----------------------------CARICAMENTO E RIEMPIMENTO CAMPI------------------------------------------------- */

    useEffect(() => {
        if (id_soggetto != null && id_soggetto != 0) {
            console.log("soggetto non nullo: id=" + id_soggetto);
            seleziona_soggetto();
        } else {
            console.log("soggetto nullo");
        }
    }, []);



    function seleziona_soggetto() {
        console.log("Carico e seleziono i dettagli :" + id_soggetto);
        if (id_soggetto !== 0) {
            EPService.selezionaRichiesta(id_soggetto)
                .then(response => {
                    console.log(response.data);
                    retrive(response.data);


                })
                .catch(e => {
                    console.log(e);

                });
        }

    }


    function retrive(data) {

       // console.log(data);
        setRichiesta({
            idRichiesta: data.idRichiesta,
            id_utente: data.id_utente,
            manifestazione: data.manifestazione,
            ragione_sociale: data.ragione_sociale,
            rappresentante_legale: data.rappresentante_legale,
            indirizzo: data.indirizzo,
            civico: data.civico,
            indirizzo2: data.indirizzo2,
            cap: data.cap,
            localita: data.localita,
            provincia: data.provincia,
            cf: data.cf,
            piva: data.piva,
            telefono: data.telefono,
            fax: data.fax,
            www: data.www,
            email: data.email, pec: data.pec,
            codice_sdi: data.codice_sdi,
            responsabile_fiera: data.responsabile_fiera,
            responsabile_fiera_telefono: data.responsabile_fiera_telefono,
            responsabile_fiera_cell: data.responsabile_fiera_cell,
            responsabile_fiera_email: data.responsabile_fiera_email,
            isEstero: data.isEstero,
            iban: data.iban,
            iban2: data.iban2,
            swift: data.swift,
            cm_01: data.cm_01, cm_01_descrizione: data.cm_01_descrizione,
            cm_02: data.cm_02, cm_02_descrizione: data.cm_02_descrizione,
            cm_03: data.cm_03, cm_03_descrizione: data.cm_03_descrizione,
            cm_04: data.cm_04, cm_04_descrizione: data.cm_04_descrizione,
            prodotti_servizi: data.prodotti_servizi,
            note: data.note,
            esigenze_espositive: data.esigenze_espositive,
            dotazioni_validate:data.dotazioni_validate,
            dotazioni: data.dotazioni,
        });
        setLista_dotazioni([]);

    }


    /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */


    const validationSchema = Yup.object().shape({

    });



    const {
        register, //register inputs
        getValues, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });



    useEffect(() => {


        console.log("Cambiata reg->riempo i campi  " + richiesta.idRichiesta);

        richiesta.dotazioni.map(dot => {


            let icon = (<Icon>edit</Icon>);

            if (dot.tipo_dotazione == "PE") icon = (<EngineeringRoundedIcon />);
            if (dot.tipo_dotazione == "PA") icon = (<DriveEtaRoundedIcon></DriveEtaRoundedIcon>);
            if (dot.tipo_dotazione == "IO") icon = (<CardGiftcardRoundedIcon></CardGiftcardRoundedIcon>);
            if (dot.tipo_dotazione == "IR") icon = (<LocalAtmRoundedIcon></LocalAtmRoundedIcon>);
            let string_tipo_dotazione = "***";
            if (dot.tipo_dotazione == "PE") string_tipo_dotazione = "PASS ESPOSITORE";
            if (dot.tipo_dotazione == "PA") string_tipo_dotazione = "PASS AUTO";
            if (dot.tipo_dotazione == "IO") string_tipo_dotazione = "INVITI OMAGGIO";
            if (dot.tipo_dotazione == "IR") string_tipo_dotazione = "INVITI RIDOTTI";

            let name_var = 'quantita_' + dot.id_dotazione;
            let field_quantita = (
                <MDInput type="text" label="Quantita" name={name_var} fullWidth   {...register(name_var)} InputLabelProps={{ shrink: true }} />
            );

            setValue(name_var, dot.quantita);

            lista_dotazioni.push({
                id_dotazione: dot.id_dotazione,
                origine: dot.origine,
                tipo_dotazione: dot.tipo_dotazione,
                id_partecipazione: dot.id_partecipazione,
                id_richiesta: dot.id_richiesta,
                quantita: dot.quantita,
                icon: icon,
                string_tipo_dotazione: string_tipo_dotazione,
                field_quantita: field_quantita,
            })

        }


        );



        setValue("dotazioni_validate", richiesta.dotazioni_validate);

    }, [richiesta]);

    /*------------------------FUNZIONALITA PAGINA------------------------------------------- */





    /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */




    const [submitted, setSubmitted] = useState(false);


    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);



    const salva_pp = (formData) => {
        if (AuthService.isTokenOk()) {

            //  console.log("salva :::::::: MODO=" + modo);
            setError(null);

            //costruisco dotazioni
            let dotazioni = [{}];
            lista_dotazioni.map(dot => {

                const nome_var = 'quantita_' + dot.id_dotazione;
                //   console.log(" ::::::::" + formData[nome_var]);  
                var dotazione = {
                    id_dotazione: dot.id_dotazione,
                    origine: dot.origine,
                    tipo_dotazione: dot.tipo_dotazione,
                    quantita: formData[nome_var],
                };
                dotazioni.push(dotazione);
            });


            var data = {
                idRichiesta: richiesta.idRichiesta,
                manifestazione: richiesta.manifestazione,
                dotazioni_validate: formData.dotazioni_validate,
                dotazioni: dotazioni,
            };


            EPService.salva_dotazioni(richiesta.idRichiesta, data)
                .then(response => {
                    handleResponse(response, 'OK');
                })
                .catch(errore => {
                    handleError(errore);
                });

        }

    }

    function handleResponse(response, op) {
        //   console.log(response.data);
        setSubmitted(true);

        navigate("/expo_partecipazioni_dotazioni", { state: { submitted: true, salvato: op, indietro: true } });
    }


    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("EEROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }




    /* ------------------------------navigazione -----------------------------------------------------------------*/


    const annulla = () => {
        navigate("/" + chiamante, { state: { indietro: true } });
    }

    const handleKeyDown = (e) => {
        const { key, target } = e

        if (key !== "Enter" || target instanceof HTMLTextAreaElement) {
            return
        }

        e.preventDefault()
    }


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>

                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card >
                            <HeaderForm titolo={"Dati Partecipazione " + richiesta.manifestazione} modo='edit'
                                save={handleSubmit(salva_pp)}
                                exit={annulla} />
                            <MDBox pt={1} pb={3} px={3} component="form" role="form" onKeyDown={handleKeyDown}>
                                <CardContent>
                                    <MDBox>
                                        <MDBox opacity={1} textAlign="center">

                                        </MDBox>
                                        <MDBox pt={4} pb={3} px={3} >

                                            <MDBox mt={5}>
                                                <ExpoRichiesteVis prop={richiesta}></ExpoRichiesteVis>
                                                <MDBox>
                                                    {/*dotazioni*/}
                                                    <Card sx={{ height: "100%", boxShadow: true && "none" }}>
                                                        <MDBox pt={2} px={2}>
                                                            <MDTypography color='success' sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                                                                &nbsp;&nbsp;Dotazioni:&nbsp;
                                                            </MDTypography>
                                                        </MDBox>

                                                        <MDBox sx={{ display: 'grid', gap: 5, my: 1, gridTemplateColumns: '1fr 3fr 2fr 2fr' }}>
                                                            <MDTypography variant="button" fontWeight="medium">

                                                            </MDTypography>
                                                            <MDTypography variant="button" fontWeight="medium">
                                                                Dotazione
                                                            </MDTypography>
                                                            <MDTypography variant="button" fontWeight="medium">
                                                                Origine
                                                            </MDTypography>
                                                            <MDTypography variant="button" fontWeight="medium">
                                                                Quantita
                                                            </MDTypography>

                                                        </MDBox>



                                                        {lista_dotazioni.map(dot => (

                                                            <MDBox sx={{ display: 'grid', gap: 5, my: 1, gridTemplateColumns: '1fr 3fr 2fr 2fr' }}>
                                                                {dot.icon}
                                                                <MDTypography variant="button" fontWeight="medium">
                                                                    {dot.string_tipo_dotazione}
                                                                </MDTypography>
                                                                <MDTypography variant="button" fontWeight="medium">
                                                                    {dot.origine}
                                                                </MDTypography>
                                                                {dot.field_quantita}


                                                            </MDBox>


                                                        ))}

                                                    </Card>

                                                </MDBox>

                                                <MDBox>
                                                    {/*validazione dotazioni*/}
                                                    <Card sx={{ height: "100%", boxShadow: true && "none" }}>
                                                        <MDBox pt={2} px={2}>
                                                            <MDTypography color='success' sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                                                                &nbsp;&nbsp;Dotazioni Validate:&nbsp;
                                                            </MDTypography>
                                                        </MDBox>

                                                        <MDBox p={2}>
                                                            <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>


                                                                <MDBox sx={{ display: 'grid', gap: 1, gridTemplateColumns: '4fr 1fr' }}>
                                                                    <MDTypography variant="button" fontWeight="medium">
                                                                        Dotazioni Validate
                                                                    </MDTypography>
                                                                    <MDBox>
                                                                        <ReactHookFormCheckBox label={<MDBox><MDTypography variant="button"
                                                                            fontWeight="regular" color="text"
                                                                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                                                                            &nbsp;&nbsp;Validato&nbsp;
                                                                        </MDTypography>
                                                                        </MDBox>} name="dotazioni_validate" control={control} /></MDBox>

                                                                </MDBox></MDBox></MDBox>
                                                    </Card>
                                                </MDBox>

                                                <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt={4} mb={1}>
                                                    <MDButton variant="outlined" color="success" onClick={annulla} >
                                                        annulla
                                                    </MDButton>
                                                    <MDBox sx={{ flex: '1 1 auto' }} />
                                                    <MDBox ml={2}>

                                                    </MDBox>
                                                    <MDBox ml={2}>
                                                        <MDButton variant="gradient" color="success" onClick={handleSubmit(salva_pp)} type="submit"  >
                                                            Salva
                                                        </MDButton>
                                                    </MDBox>

                                                </MDBox>


                                            </MDBox>

                                        </MDBox>



                                    </MDBox>


                                </CardContent>
                            </MDBox>
                        </Card>
                    </Grid></Grid></MDBox>
            <Footer />
        </DashboardLayout>
    )
}


export default ExpoDotazioniEdit;